/**
 * @file RiskComparison.jsx
 * @description Main application interface with role-specific features
 * 
 * @section Responsibilities
 * - Manage role-based views
 * - Handle data aggregation
 * - Control real-time updates
 * - Manage user preferences
 * 
 * @section Dependencies
 * - Role Management: Access control
 * - Data Services: Information handling
 * - State Management: Global state
 * 
 * @section Integration Points
 * - Data API: Information retrieval
 * - Role System: Access control
 * - Notification System: Real-time updates
 * 
 * @section State Management
 * - dashboardData: Aggregated information
 * - loadingState: Data fetching
 * - errorState: Error handling
 * 
 * @section Events
 * - onDataUpdate: Data changes
 * - onError: Error handling
 * - onPreferenceChange: Settings updates
 * 
 * @section Props
 * @prop {String} userRole - Current user role
 * @prop {Object} permissions - User permissions
 */

import React from 'react'
import Widget from '../Widget'
import RiskScore from '../../../../components/dashboard/RiskScore'
import DgButton from '../../../../components/DgButton'
import Tip from '../../../../components/Tip'

function RiskComparison({ width }) {
  return (
    <Widget name={"risk-comparison"} width={width}>
      <div className="heading">
        <h1 className="title">Risk Comparison</h1>
      </div>
      <div className="score-comparison">
        <div className="risk-cont">
          <RiskScore score={350} gradient={"blue"} />
          <p>Tolerance risk score</p>
        </div>
        <img src="/assets/icons/compare.svg" alt="" />
        <div className="risk-cont">
          <RiskScore score={365} gradient={"orange"} />
          <p>Your investment<br />strategy's risk score</p>
        </div>
      </div>
      <DgButton category="danger" size="small" text="Risk Test" />
      <Tip text={"Hey there! Your risk score is higher than your risk tolerance score. Do you want to keep your current portfolio or make adjustments to reduce risk and align with your score?"} link={"Let us know if you need help."} href={""} />
    </Widget>
  )
}

export default RiskComparison